import script from "./ThumbPeek.vue?vue&type=script&setup=true&lang=js"
export * from "./ThumbPeek.vue?vue&type=script&setup=true&lang=js"

import "./ThumbPeek.vue?vue&type=style&index=0&id=a54c41ee&scoped=true&lang=css"

import exportComponent from "/home/passani/git_repos/onlineimageoptimizer.com/image-optimizer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a54c41ee"]])

export default __exports__